import React from 'react'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import Content from '../components/Content'
import Intro from '../components/Intro'
import Products from '../components/Products'
import BusinessVerticals from '../components/BusinessVerticals'
import Footer from '../components/Footer'
import Partners from '../components/Partners'
import Map from '../components/Map'
import Gallery from '../components/Gallery'
import SeoInsights from '../components/SeoInsights'

function Home() {
  return (
    <div>
        <Navbar />
        <Hero />
        <Content />
        <Intro />
        <Products />
        <BusinessVerticals />
        <SeoInsights />
        <Gallery />
        <Map />
        <Footer />
        <Partners />
    </div>
  )
}

export default Home